<template>
  <div class="currentBiddings">
    <HeaderNavigation title="ny budgivning"/>
    <div class="filter">
      <input type="text" v-model="filter" placeholder="Filtrera listan" class="width-100 mb-15 sticky">
      <img v-show="filter" @click="clearFilter" alt="icon" src="@/assets/icons/remove.svg">
    </div>
    <div class="container container--withfilter" v-if="listingsWithActiveBiddings">
      <div v-for="listing in listingsWithActiveBiddings" v-bind:key="listing.id" class="borders listing-list mb-5">
        <router-link :to="{ name: 'singlebiddingobject', params: listing }">
          <div class="listing-data">
            <div>
              <h3 class="bold">{{ listing.address }}</h3>
            </div>
            <p class="listing-list__price">{{ $root.formatPrice(listing.price) }} kr</p>
          </div>
        </router-link>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import HeaderNavigation from '../components/HeaderNavigation';

export default {
  name: 'NewBidding',
  data() {
    return {
      filter: ''
    }
  },
  computed: {
    listingsWithActiveBiddings() {
      // Filter by input "Filtrera listan"
      return this.$store.state.allRecentListings.filter(item => {
        if (item.address) {
          return item.address.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
        }
      })
    }
  },
  methods: {
    formatPrice(price) {
      return window.helpers.formatPrice(price);
    },
    clearFilter(){
      this.filter = "";
    }
  },
  created() {
    // Get all recent listings...
    this.$store.dispatch('storeAllRecentListings');
  },
  components: {
    Footer,
    HeaderNavigation
  },
}
</script>

<style>
.filter {
  position: fixed;
  top: 66px;
  z-index: 500;
  left:0;
  right:0;
  padding-left: 15px;
  padding-right: 15px;
  background-color: var(--fasad-grey-1);
}
.filter img {
  position: absolute;
  right: 30px;
  top: 18px;
}
.container--withfilter {
  padding-top: 135px;
}
</style>
